import { v4 as uuid } from "uuid";
import predefinedDashboardMenu from "../components/widgetDashboard/predefined/predefined.dashBoard.menu";
import { PredefinedDashboard, WidgetTypes } from "../components/widgetDashboard/widgetDashboard.enums";
import { WidgetConfig, WidgetDashboardConfig, PredefinedDashboardMenuType, DashboardSyncSettings } from "../components/widgetDashboard/widgetDashboard.interface";
import { ScalperLayouts, ScalperDefaultWidgetTypes } from "../pages/scalper/scalper.typings";
import { User } from "../proto/generated/identity";
import { Security } from "../proto/generated/security";
import { DashboardNamespace, DashboardShareStatus, Platform, UserDashboardProto } from "../proto/generated/user-preference";
import { DropDownExpiries } from "../reducer/options.reducer";
import { initialState } from "../reducer/user.reducer";
import { updateUserPreferences } from "../services/apis/user";
import { fetchOptionExpiriesV2 } from "./options";
import { getSecurityAsync, getSecurityKey } from "./security";
import store from "../store";
import { saveUserDashboard } from "../services/apis/dashboard";
import { SCALPER_DEFAULT_LAYOUT, SCALPER_DEFAULT_PREDEFINED_LAYOUT } from "../assets/constants";


export const getLayoutWidgetTypes = (scalperLayout: ScalperLayouts, predefinedLayout: PredefinedDashboard): Record<number, ScalperDefaultWidgetTypes> | void => {
    switch (scalperLayout) {
        case ScalperLayouts.CALL_AND_PUT:
            return {
                2: ScalperDefaultWidgetTypes.CALL_OPTION_CHART,
                3: ScalperDefaultWidgetTypes.PUT_OPTION_CHART
            }
        case ScalperLayouts.SPOT_CALL_OR_PUT:
            return {
                2: ScalperDefaultWidgetTypes.SPOT_CHART,
                3: ScalperDefaultWidgetTypes.CALL_OPTION_CHART
            }
        case ScalperLayouts.MULTI_CALL_OR_PUT:
            return {
                2: ScalperDefaultWidgetTypes.MULTISTRIKE_CHART,
                3: ScalperDefaultWidgetTypes.CALL_OPTION_CHART
            }
        case ScalperLayouts.SPOT_CALL_AND_PUT:
            switch (predefinedLayout) {
                case PredefinedDashboard.LAYOUT_H3:
                case PredefinedDashboard.LAYOUT_V3:
                    return {
                        2: ScalperDefaultWidgetTypes.CALL_OPTION_CHART,
                        3: ScalperDefaultWidgetTypes.SPOT_CHART,
                        4: ScalperDefaultWidgetTypes.PUT_OPTION_CHART
                    }
                case PredefinedDashboard.LAYOUT_H2_1V2:
                case PredefinedDashboard.LAYOUT_V2_1H2:
                    return {
                        3: ScalperDefaultWidgetTypes.CALL_OPTION_CHART,
                        4: ScalperDefaultWidgetTypes.PUT_OPTION_CHART,
                        5: ScalperDefaultWidgetTypes.SPOT_CHART
                    }
                case PredefinedDashboard.LAYOUT_H2_2V2:
                case PredefinedDashboard.LAYOUT_V2_2H2:
                    return {
                        2: ScalperDefaultWidgetTypes.SPOT_CHART,
                        4: ScalperDefaultWidgetTypes.CALL_OPTION_CHART,
                        5: ScalperDefaultWidgetTypes.PUT_OPTION_CHART
                    }
            }
            return {}
        case ScalperLayouts.MULTI_CALL_AND_PUT:
            switch (predefinedLayout) {
                case PredefinedDashboard.LAYOUT_H3:
                case PredefinedDashboard.LAYOUT_V3:
                    return {
                        2: ScalperDefaultWidgetTypes.CALL_OPTION_CHART,
                        3: ScalperDefaultWidgetTypes.MULTISTRIKE_CHART,
                        4: ScalperDefaultWidgetTypes.PUT_OPTION_CHART
                    }
                case PredefinedDashboard.LAYOUT_H2_1V2:
                case PredefinedDashboard.LAYOUT_V2_1H2:
                    return {
                        3: ScalperDefaultWidgetTypes.CALL_OPTION_CHART,
                        4: ScalperDefaultWidgetTypes.PUT_OPTION_CHART,
                        5: ScalperDefaultWidgetTypes.MULTISTRIKE_CHART
                    }
                case PredefinedDashboard.LAYOUT_H2_2V2:
                case PredefinedDashboard.LAYOUT_V2_2H2:
                    return {
                        2: ScalperDefaultWidgetTypes.MULTISTRIKE_CHART,
                        4: ScalperDefaultWidgetTypes.CALL_OPTION_CHART,
                        5: ScalperDefaultWidgetTypes.PUT_OPTION_CHART
                    }
            }
            return {};
        case ScalperLayouts.SPOT_MULTI_CALL_AND_PUT:
            switch (predefinedLayout) {
                case PredefinedDashboard.LAYOUT_H2_1V2_2V2:
                    return {
                        3: ScalperDefaultWidgetTypes.SPOT_CHART,
                        4: ScalperDefaultWidgetTypes.CALL_OPTION_CHART,
                        6: ScalperDefaultWidgetTypes.MULTISTRIKE_CHART,
                        7: ScalperDefaultWidgetTypes.PUT_OPTION_CHART,
                    }
                case PredefinedDashboard.LAYOUT_H4:
                case PredefinedDashboard.LAYOUT_V4:
                    return {
                        2: ScalperDefaultWidgetTypes.CALL_OPTION_CHART,
                        3: ScalperDefaultWidgetTypes.SPOT_CHART,
                        4: ScalperDefaultWidgetTypes.MULTISTRIKE_CHART,
                        5: ScalperDefaultWidgetTypes.PUT_OPTION_CHART,
                    }
                case PredefinedDashboard.LAYOUT_H2_2V3:
                case PredefinedDashboard.LAYOUT_V2_2H3:
                    return {
                        2: ScalperDefaultWidgetTypes.SPOT_CHART,
                        4: ScalperDefaultWidgetTypes.MULTISTRIKE_CHART,
                        5: ScalperDefaultWidgetTypes.CALL_OPTION_CHART,
                        6: ScalperDefaultWidgetTypes.PUT_OPTION_CHART,
                    }
                case PredefinedDashboard.LAYOUT_H2_1V3:
                    return {
                        3: ScalperDefaultWidgetTypes.MULTISTRIKE_CHART,
                        4: ScalperDefaultWidgetTypes.CALL_OPTION_CHART,
                        5: ScalperDefaultWidgetTypes.PUT_OPTION_CHART,
                        6: ScalperDefaultWidgetTypes.SPOT_CHART,
                    }
                case PredefinedDashboard.LAYOUT_V2_1H2_2V2:
                case PredefinedDashboard.LAYOUT_H2_1H2_2V2:
                    return {
                        3: ScalperDefaultWidgetTypes.SPOT_CHART,
                        4: ScalperDefaultWidgetTypes.MULTISTRIKE_CHART,
                        6: ScalperDefaultWidgetTypes.CALL_OPTION_CHART,
                        7: ScalperDefaultWidgetTypes.PUT_OPTION_CHART,
                    }
                

            }
    }

}


export const ScalperDefaultWidgets: Partial<Record<ScalperLayouts, ScalperDefaultWidgetTypes[]>> = {
    [ScalperLayouts.CALL_AND_PUT]: [ScalperDefaultWidgetTypes.CALL_OPTION_CHART, ScalperDefaultWidgetTypes.PUT_OPTION_CHART],
    [ScalperLayouts.SPOT_CALL_OR_PUT]: [ScalperDefaultWidgetTypes.SPOT_CHART, ScalperDefaultWidgetTypes.OPTION_CHART],
    [ScalperLayouts.MULTI_CALL_OR_PUT]: [ScalperDefaultWidgetTypes.MULTISTRIKE_CHART, ScalperDefaultWidgetTypes.OPTION_CHART],
    [ScalperLayouts.SPOT_CALL_AND_PUT]: [ScalperDefaultWidgetTypes.SPOT_CHART, ScalperDefaultWidgetTypes.CALL_OPTION_CHART, ScalperDefaultWidgetTypes.PUT_OPTION_CHART],
    [ScalperLayouts.MULTI_CALL_AND_PUT]: [ScalperDefaultWidgetTypes.MULTISTRIKE_CHART, ScalperDefaultWidgetTypes.CALL_OPTION_CHART, ScalperDefaultWidgetTypes.PUT_OPTION_CHART],
    [ScalperLayouts.SPOT_MULTI_CALL_AND_PUT]: [ ScalperDefaultWidgetTypes.SPOT_CHART, ScalperDefaultWidgetTypes.MULTISTRIKE_CHART, ScalperDefaultWidgetTypes.CALL_OPTION_CHART, ScalperDefaultWidgetTypes.PUT_OPTION_CHART]
}

export const getScalperWidgets = async (dashboardId: string, scalperLayout: ScalperLayouts, predefinedDashboard: PredefinedDashboard,
    underlyingSecurity: Security, callSecurity: Security, putSecurity: Security,
    isLayoutChanged: boolean, isUnderlyingChanged: boolean, isPredefinedLayoutChanged: boolean, ltp: number, expiry?: DropDownExpiries, currentLayout?: WidgetDashboardConfig): Promise<Record<number, WidgetConfig<any>>> => {

    const widgetConfigs: Record<number, WidgetConfig<any>> = {}

    const scalperWidgets = getLayoutWidgetTypes(scalperLayout, predefinedDashboard);

    if (!scalperWidgets) return {};

    for (let key in scalperWidgets) {
        const slotId = Number(key);
        let widgetType = scalperWidgets[slotId];
        if (!isLayoutChanged && !isUnderlyingChanged && (currentLayout ? currentLayout.widgets[slotId] : null)) {
            widgetConfigs[slotId] = currentLayout ? currentLayout.widgets[slotId] : null;
            widgetType = (await convertWidgetTypeToScalperWidgetType(currentLayout!.widgets[slotId])) || widgetType;
            continue;
        }
        widgetConfigs[slotId] = getScalperWidget(dashboardId, slotId, widgetType, underlyingSecurity, callSecurity, putSecurity, currentLayout ? currentLayout.widgets[slotId] : undefined)
    }
    return widgetConfigs;
}

export const convertWidgetTypeToScalperWidgetType = async (widgetConfig: WidgetConfig<any>): Promise<ScalperDefaultWidgetTypes | null> => {
    switch (widgetConfig.widgetType) {
        case WidgetTypes.CHART:
            return ScalperDefaultWidgetTypes.SPOT_CHART;
        case WidgetTypes.MULTI_STRIKE_CHART:
            return ScalperDefaultWidgetTypes.MULTISTRIKE_CHART;
        default:
            return null;
    }
}


export const getScalperWidget = (
    dashboardId: string,
    slotId: number,
    widgetType: ScalperDefaultWidgetTypes,
    underlyingSecurity: Security,
    callSecurity: Security,
    putSecurity: Security,
    currentConfig?: WidgetConfig<any>
): WidgetConfig<any> => {
    const key = getSecurityKey(underlyingSecurity.exchange, underlyingSecurity.code)
    const callSecurityKey = getSecurityKey(callSecurity.exchange, callSecurity.code);
    const putSecurityKey = getSecurityKey(putSecurity.exchange, putSecurity.code);

    switch (widgetType) {
        case ScalperDefaultWidgetTypes.SPOT_CHART:
            return {
                slotId,
                widgetType: WidgetTypes.CHART,
                settings: {
                    chartId: `${dashboardId}-${slotId}`,
                    key,
                    securities: [key],
                    expressionMode: false
                }
            }
        case ScalperDefaultWidgetTypes.CALL_OPTION_CHART:
            return {
                slotId,
                widgetType: WidgetTypes.CHART,
                settings: {
                    chartId: `${dashboardId}-${slotId}`,
                    key: callSecurityKey,
                    underlyingKey: key,
                    securities: [callSecurityKey],
                    expressionMode: false
                }
            }
        case ScalperDefaultWidgetTypes.PUT_OPTION_CHART:
            return {
                slotId,
                widgetType: WidgetTypes.CHART,
                settings: {
                    chartId: `${dashboardId}-${slotId}`,
                    key: putSecurityKey,
                    underlyingKey: key,
                    securities: [putSecurityKey],
                    expressionMode: false
                }
            }
        case ScalperDefaultWidgetTypes.OPTION_CHART:
            return {
                slotId,
                widgetType: WidgetTypes.CHART,
                settings: {
                    chartId: `${dashboardId}-${slotId}`,
                    key: callSecurityKey,
                    underlyingKey: key,
                    securities: [callSecurityKey],
                    expressionMode: false
                }
            }
        case ScalperDefaultWidgetTypes.MULTISTRIKE_CHART:
            return {
                slotId,
                widgetType: WidgetTypes.MULTI_STRIKE_CHART,
                settings: {
                    chartId: `${dashboardId}-${slotId}`,
                    key,
                    securities: [key],
                    expressionMode: false
                }
            }
        default:
            return {
                slotId,
                widgetType: WidgetTypes.CHART,
                settings: {
                    chartId: `${dashboardId}-${slotId}`,
                    key,
                    securities: [key],
                    expressionMode: false
                }
            }
    }
}

export const ScalperLayoutName: Record<ScalperLayouts, string> = {
    [ScalperLayouts.CALL_AND_PUT]: "Call & Put",
    [ScalperLayouts.SPOT_CALL_OR_PUT]: "Spot + Call/Put",
    [ScalperLayouts.MULTI_CALL_OR_PUT]: "Multi Strike + Call/Put",
    [ScalperLayouts.SPOT_CALL_AND_PUT]: "Spot + Call & Put",
    [ScalperLayouts.MULTI_CALL_AND_PUT]: "Multi Strike + Call & Put",
    [ScalperLayouts.SPOT_MULTI_CALL_AND_PUT]: "Spot + Multi Strike + Call & Put"
}

export const ScalperLayoutToPredefinedLayoutsMap: Record<ScalperLayouts, PredefinedDashboardMenuType[]> = Object.keys(ScalperLayouts).reduce((acc, scalperLayout) => {
    const widgetCount = ScalperDefaultWidgets[scalperLayout]?.length || 0
    const menuItems = Object.values(predefinedDashboardMenu).flat()
    acc[scalperLayout] = menuItems.filter(predefinedLayout => predefinedLayout.wrapper.panesCount == widgetCount)
    return acc;
}, {} as Record<ScalperLayouts, PredefinedDashboardMenuType[]>)

export const updateDefaultScalperSettings = async (user: User) => {
    let updatedUser = user;
    try {
        const preferences = JSON.parse(user.preferences || '{}');
        if (!preferences.scalperSettings) {
            const newPreferences = await updateUserPreferences({
                body: {
                    scalperSettings: initialState.userDetails.preferences.scalperSettings
                }
            });
            updatedUser.preferences = newPreferences.preferences
        }
    } catch (e) {
        console.warn('Default scalper prefs skipped', e)
    }
    return updatedUser;
}


export const createDefaultScalperLayout = async (
    isMobile: boolean, underlyingToken: string, expiry: DropDownExpiries, ltp: number, syncSettings?: Partial<DashboardSyncSettings>, scalperLayoutId?: string
): Promise<UserDashboardProto | void> => {
    const layoutId = scalperLayoutId ||uuid().replace(/[-]*/g, '').split('').slice(0, 10).join('');
    const dashboard = await getLayoutWidgets(
        layoutId,
        await getSecurityAsync(underlyingToken),
        SCALPER_DEFAULT_LAYOUT,
        SCALPER_DEFAULT_PREDEFINED_LAYOUT,
        true,
        true,
        true,
        ltp,
        expiry,
        undefined
    );

    if (!dashboard) return;

    const layoutToBeSaved = {
        panes: dashboard.panes,
        widgets: dashboard.widgets,
        syncSettings: {
            ...dashboard.syncSettings,
            ...(syncSettings || {})
        },
        charts: {},
        drawings: {}
    }

    const newLayout = {
        id: layoutId,
        layout: JSON.stringify(layoutToBeSaved),
        name: 'Scalper',
        isDefault: true,
        isPredefined: false,
        shareState: DashboardShareStatus.NOT_SHARED,
        platform: isMobile ? Platform.MOBILE : Platform.DESKTOP,
        namespace: DashboardNamespace.SCALPER
    }

    await saveUserDashboard({
        dashboard: newLayout
    })

    return newLayout
}


export const getLayoutWidgets = async (
        layoutId: string, underlyingSecurity: Security, scalperLayout: ScalperLayouts, predefinedLayout: PredefinedDashboard,
        isLayoutChanged: boolean, isPredefinedLayoutChanged: boolean, isUnderlyingChanged: boolean, ltp: number, expiry?: DropDownExpiries, currentDashboard?: WidgetDashboardConfig,
    ) : Promise<WidgetDashboardConfig | void> => {
        const nearExpiry = expiry || (await getNearExpiry(underlyingSecurity))
        if (!nearExpiry?.strikes?.length) return;

        const atmStrike = await getAtmStrike(underlyingSecurity, nearExpiry, ltp);
        const strike = nearExpiry.strikes.find(s => s.strike === atmStrike) ?? nearExpiry.strikes[0];
        if (!strike?.callSecurity || !strike?.putSecurity) return;

        const callSecurity = await getSecurityAsync(getSecurityKey(strike.callSecurity.exchange, strike.callSecurity.code))
        const putSecurity = await getSecurityAsync(getSecurityKey(strike.putSecurity.exchange, strike.putSecurity.code))
        if (!callSecurity || !putSecurity) return;

        const widgets = await getScalperWidgets(layoutId, scalperLayout, predefinedLayout, underlyingSecurity, callSecurity, putSecurity, isLayoutChanged, isUnderlyingChanged, isPredefinedLayoutChanged, ltp, nearExpiry, currentDashboard);

        let predefinedItem: PredefinedDashboardMenuType | null = null;
        for (let menu of predefinedDashboardMenu) {
            for (let pd of menu) {
                if (pd.id === predefinedLayout) {
                    predefinedItem = pd;
                    break;
                }
            }
        }
        if (!predefinedItem) return;

        // Use new panes when either scalperLayout or predefinedLayout changes - old panes structure
        // may not match the new widget count (e.g. 2-pane vs 3-pane layout)
        const useNewPanes = isLayoutChanged || isPredefinedLayoutChanged
        return {
                ...predefinedItem.wrapper.dashboardConfig,
                panes: !useNewPanes && currentDashboard?.panes ? currentDashboard.panes : predefinedItem.wrapper.dashboardConfig.panes,
                widgets,
                syncSettings: {
                    security: true,
                    timeBucket: false,
                    crosshair: true,
                    time: false,
                    drawing: false
                }
            };
    };

export const getNearExpiry = async (primaryOrUnderlying: Security) => {
    const response = await fetchOptionExpiriesV2({ exchange: primaryOrUnderlying.exchange, code: primaryOrUnderlying.code }, store.dispatch);
    return response.length ? response[0]: null
};

const getAtmStrike = async (security: Security, expiry: DropDownExpiries, ltp: number) => {
    const { strikes } = expiry;
    if (!strikes?.length) return undefined;

    const sorted = strikes.slice().sort((a, b) => a.strike - b.strike);
    // When LTP is missing (common right after restart before snapshot/ws update),
    // fall back to mid strike instead of throwing on strikes[i-1] at i=0.
    if (!ltp || ltp <= 0) {
        return sorted[Math.floor(sorted.length / 2)]?.strike ?? sorted[0]?.strike;
    }

    for (let i = 0; i < sorted.length; i++) {
        const strike = sorted[i];
        if (strike.strike > ltp) {
            if (i === 0) return strike.strike;
            const lowerStrike = sorted[i - 1];
            const higherStrike = strike;
            const lowerDiff = Math.abs(ltp - lowerStrike.strike);
            const higherDiff = Math.abs(ltp - higherStrike.strike);
            return (lowerDiff < higherDiff ? lowerStrike : higherStrike).strike;
        }
    }
    return sorted[sorted.length - 1]?.strike;
};